import { createContext } from 'use-context-selector';

export interface AnalyticsContextProps {
  version?: string;
  environment?: string;
  facebook?: {
    appId: string;
    clientToken: string;
  };
}

export const AnalyticsContext = createContext<AnalyticsContextProps>({});
